// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import { plural } from 'pluralize';
import LoadingContent from 'shared/components/LoadingContent';
import actions from './actions';
import { Link } from 'react-router';

class Show extends Component {
  constructor() {
    super();
    this.state = { profile: null };
  }

  componentDidMount() {
    actions.fetchProfile(this.props.params.providerId).then(profile => this.setState({ profile }));
  }

  render() {
    if (!this.state.profile) return <LoadingContent />;
    return <PresentationComponent profile={this.state.profile} />;
  }
}

const PresentationComponent = ({ profile: { provider, nearbys, mapString } }) => (
  <Page title={`User: ${provider.nameWithAppellation}`}>
    <Row>
      <Widget title="Profile" icon="user" span={12}>
        <Row>
          <div className="span1">
            <img src={provider.profileImagePath} id="provider_image" alt="profile" />
          </div>
          <div className="span4">
            <h3>{provider.nameWithAppellation}</h3>
            <br />
            <b>NPI #: </b>
            {provider.npi}
          </div>
          <div className="span4">
            <h4>{plural('Location', provider.locations.length)}:</h4>
            {provider.locations.map(location => (
              <div key={location.id}>
                --------------------------------------
                <address>
                  {location.streetAddress}
                  <br />
                  {location.city}, {location.state}, {location.zip}
                  <br />
                  {location.phone}
                  <br />
                  {location.fax}
                </address>
              </div>
            ))}
          </div>
          <div className="span3">
            <h4>Areas of Care:</h4>
            <ul>
              {provider.specialtyNames.map(specName => (
                <li key={specName}>{specName}</li>
              ))}
            </ul>
          </div>
        </Row>
      </Widget>
    </Row>
    <Row>
      <Widget span={6} icon="home" title={plural('Location', provider.locations.length)}>
        <img src={mapString} alt="map" />
      </Widget>
      <Widget span={6} icon="users" title="Nearby Providers" id="nearby_specialists">
        {nearbys.length > 0 ? (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Specialty</th>
                <th>Providers</th>
              </tr>
            </thead>
            <tbody>
              {nearbys.map(nearby => (
                <tr key={nearby.name}>
                  <td>{nearby.name}</td>
                  <td>
                    <ul>
                      {nearby.docs.map(doc => (
                        <li key={doc.id}>
                          <Link to={`/a/portal/providers/${doc.id}/profile`}>
                            {doc.nameWithAppellation}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="well">
            <p>User has not updated location, or no nearby registered users.</p>
          </div>
        )}
      </Widget>
    </Row>
  </Page>
);

export default Show;
